import React, { useState, useRef, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Trash2Icon } from "lucide-react";
import { uri } from "constants/common";

import Api, { translationForm } from "../services/api";
const apiService = new Api();
const TranslationRequestForm = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        language: "",
        dateNeeded: "",
        numberOfPages: "",
        description: "",
        instructions: "",
        department: "",
        principal: "",
        principalEmail: "",
        files: [],
    });
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [languages, setLanguages] = useState([]);

    const handleInputChange = (name, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === "email" || name === "principalEmail") {
            const emailRegex = /^[^\s@]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

            setErrors((prevErrors) => {
                if (!value.trim()) {
                    return { ...prevErrors, [name]: "Email is required" };
                } else if (!emailRegex.test(value)) {
                    return { ...prevErrors, [name]: "Enter a valid email address" };
                } else {
                    return { ...prevErrors, [name]: undefined };
                }
            });
        } else {
            setErrors((prevErrors) => {
                if (prevErrors[name]) {
                    return { ...prevErrors, [name]: undefined };
                }
                return prevErrors;
            });
        }
    };
    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const response = await fetch(uri + '/get-languages');
                const data = await response.json();
                if (data.success) {
                    const filtered = data.data.filter(lang => lang.id !== 1 && lang.id !== 2);
                    setLanguages(filtered); // Store only filtered languages
                }
            } catch (error) {
                console.error('Error fetching languages:', error);
            }
        };

        fetchLanguages();
    }, []);
    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setFormData((prev) => ({
            ...prev,
            files: [...prev.files, ...newFiles], // append files
        }));
    };


    const {
        handleSubmit,
        formState: { error },
        control,
        setValue,
    } = useForm();
    const dispatch = useDispatch();
    const [dragActive, setDragActive] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const inputRef = useRef(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleBrowseClick = () => {
        inputRef.current.click();
    };

    const handleRemoveFile = (index) => {
        setSelectedFiles((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            console.log("updated", updated);
            setValue("files", updated);
            return updated;
        });
    };

    console.log("Selected files:", selectedFiles);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Must be a valid email";
        }

        if (!formData.language) newErrors.language = "Language is required";
        if (!formData.dateNeeded) {
            newErrors.dateNeeded = "Date is required";
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // aaj ki date midnight se

            const selectedDate = new Date(formData.dateNeeded);

            if (isNaN(selectedDate.getTime())) {
                newErrors.dateNeeded = "Please enter a valid date";
            } else if (selectedDate < today) {
                newErrors.dateNeeded = "Date cannot be in the past";
            }
        }
        if (!formData.numberOfPages)
            newErrors.numberOfPages = "Number of pages is required";
        if (!formData.description.trim())
            newErrors.description = "Description is required";
        if (!formData.instructions.trim())
            newErrors.instructions = "Instructions are required";
        if (!formData.department.trim())
            newErrors.department = "Department is required";
        if (!formData.principal.trim())
            newErrors.principal = "Principal name is required";

        if (!formData.principalEmail) {
            newErrors.principalEmail = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.principalEmail)) {
            newErrors.principalEmail = "Must be a valid email";
        }
        if (!selectedFiles || selectedFiles.length === 0) {
            newErrors.files = "Please upload at least one file";
        } else {
            const allowedTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "text/plain",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/csv",
                "application/rtf",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
            ];

selectedFiles.forEach((file) => {
    if (!allowedTypes.includes(file.type)) {
        newErrors.files = "Only PDF, DOC, DOCX, TXT, CSV, RTF, XLS, XLSX, PPT, and PPTX files are allowed";
    }
    if (file.size > 5 * 1024 * 1024) {
        // 5 MB limit
        newErrors.files = "File size must be less than 5MB";
    }
});
        }
setErrors(newErrors);
return Object.keys(newErrors).length === 0;
    };

const onSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);

    try {
        // ✅ payload banaya (files ko alag handle karenge)
        const apiPayload = {
            name: formData.name,
            email: formData.email,
            language_id: formData.language,
            due_date: formData.dateNeeded,
            number_of_pages: formData.numberOfPages,
            description: formData.description,
            instructions: formData.instructions,
            department: formData.department,
            principal: formData.principal,
            principal_email: formData.principalEmail,
        };

        // ✅ FormData banaye
        const formDataToSend = new FormData();

        // Append regular fields
        Object.entries(apiPayload).forEach(([key, value]) => {
            formDataToSend.append(key, value ?? "");
        });

        // ✅ Files ko backend expected nested structure me append karna
        if (Array.isArray(selectedFiles)) {
            selectedFiles.forEach((file, index) => {
                formDataToSend.append(`files[${index}]`, file);
            });
        }
        for (let [key, val] of formDataToSend.entries()) {
            console.log(key, val);
        }
        // const response = await fetch("http://127.0.0.1:8000/api/translations", {
        //     method: "POST",
        //     body: formDataToSend, // ✅ FormData ke saath files correctly ja rahi hain
        // });

        const response = await Api.translationForm(formDataToSend)


        const result = response.data

        if (result.success) {
            setLoading(false);
            Swal.fire({
                title: "Success!",
                text: result.message,
                icon: "success",
                confirmButtonText: "OK",
            }).then(() => {
                window.location.reload();
            });
            console.log("API Response:", result);
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error!",
                text: result?.message || "Submission failed. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    } catch (error) {
        setLoading(false);
        Swal.fire({
            title: "Network Error",
            text: "There was a network error. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
        });
        console.error("Error submitting form:", error);
    }
};







return (
    <div className="app-container">
        <div className="header">
            <div className="logo">
                <div className="logo_wrapper">
                    <img
                        src="/images/logo-fill.png"
                        alt="ALGOVI Logo"
                        className="logo-img"
                    />
                </div>
            </div>
            <h1 className="main-title">Translation Request Form</h1>
        </div>

        <div className="form-container">
            <div className="form-card">
                <div className="step-content">
                    <div className="step-header">
                        <h2 className="step-title">Translation Services</h2>
                        <p className="step-description">
                            Important Note:  Please sign into your SUSD Google account before beginning to complete the form.  The documents that you upload will be added to your SUSD Google Drive.
                            <br />
                            <br />
                            Please complete the form to request Written Translation Services from the Language Development Office.
                            <br />
                            WRITTEN TRANSLATION SERVICES
                            <br />
                            Please submit your translation request at least two weeks <strong>(10 working days) prior</strong> to the date needed.  Most 1-3 page documents can be completed in 3-5 days but lengthier documents need <strong>at least 10 days</strong>.  Additional pages will require additional time.  All requests will be assigned to a translator in the order received.  New Student/Parent Handbooks and Psychological and Speech reports may take up to 90 days to complete.  Other document turnaround time is based on the number of pages to be translated and the current number of translation requests district-wide.  We realize that some translations may suddenly arise, and we will make every effort to accommodate those last minute requests.
                            <br />
                            <br />
                            NOTE: Please attach a copy of the final version of the document needing translation in Microsoft Word or PowerPoint format.  NO PDFs unless they include handwritten notes that also need to be translated.  Thank you.
                            <br />
                            <br />
                            If the document has been translated before, please attach a copy of previous translation in Microsoft Word or PowerPoint format.
                            <br />
                            <br />
                            <span className='required'>* Indicates required question</span>
                        </p>
                    </div>


                    {/* name */}
                    <div className="form-group">
                        <label className="form-label">
                            Name <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            value={formData.name}
                            onChange={(e) => handleInputChange("name", e.target.value)}
                            className={`form-input ${errors.name ? "error" : ""}`}
                            placeholder="Enter your name"
                        />
                        {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    {/* Email */}
                    <div className="form-group">
                        <label className="form-label">
                            Email <span className="required">*</span>
                        </label>
                        <input
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleInputChange("email", e.target.value)}
                            className={`form-input ${errors.email ? "error" : ""}`}
                            placeholder="Enter your email address"
                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>

                    {/* Language */}
                    <div className="form-group">
                        <label className="form-label">
                            Which Language are you seeking document translation? <span className="required">*</span>
                        </label>
                        <select
                            value={formData.language}
                            onChange={(e) => handleInputChange("language", e.target.value)}
                            className={`form-input form-select ${errors.language ? "error" : ""
                                }`}
                        >
                            <option value="">-- Select Language --</option>
                            {languages.map((lang) => (
                                <option key={lang.id} value={lang.id}>
                                    {lang.name}
                                </option>
                            ))}
                        </select>
                        {errors.language && (
                            <p className="error-message">{errors.language}</p>
                        )}
                    </div>

                    {/* Date */}
                    <div className="form-group">
                        <label className="form-label">
                            Date document(s) is/are needed<span className="required">*</span> <br />
                            Please note the time frame information above when selecting the date documents are needed Date

                        </label>
                        <div className="input-image">
                            <input
                                type="date"
                                value={formData.dateNeeded}
                                onChange={(e) => handleInputChange("dateNeeded", e.target.value)}
                                className={`form-input ${errors.dateNeeded ? "error" : ""}`}
                            />
                            <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
                        </div>
                        {errors.dateNeeded && (
                            <p className="error-message">{errors.dateNeeded}</p>
                        )}
                    </div>

                    {/* Pages */}
                    <div className="form-group">
                        <label className="form-label">
                            Number of Pages <span className="required">*</span>
                        </label>
                        <input
                            type="number"
                            value={formData.numberOfPages}
                            onChange={(e) =>
                                handleInputChange("numberOfPages", e.target.value)
                            }
                            className={`form-input ${errors.numberOfPages ? "error" : ""}`}
                            placeholder="Enter number of pages"
                        />
                        {errors.numberOfPages && (
                            <p className="error-message">{errors.numberOfPages}</p>
                        )}
                    </div>

                    {/* Description */}
                    <div className="form-group">
                        <label className="form-label">
                            Document Description <span className="required">*</span>
                        </label>
                        <textarea
                            value={formData.description}
                            onChange={(e) =>
                                handleInputChange("description", e.target.value)
                            }
                            className={`form-input ${errors.description ? "error" : ""
                                }`}
                            placeholder="Provide a brief description"
                            rows={4}
                        />
                        {errors.description && (
                            <p className="error-message">{errors.description}</p>
                        )}
                    </div>

                    {/* Instructions */}
                    <div className="form-group">
                        <label className="form-label">
                            Special Instructions <span className="required">*</span> <br />
                            If none, please enter NA or None
                        </label>
                        <input
                            type="text"
                            value={formData.instructions}
                            onChange={(e) =>
                                handleInputChange("instructions", e.target.value)
                            }
                            className={`form-input ${errors.instructions ? "error" : ""
                                }`}
                            placeholder="Enter special instructions"
                        />
                        {errors.instructions && (
                            <p className="error-message">{errors.instructions}</p>
                        )}
                    </div>

                    {/* Department */}
                    <div className="form-group">
                        <label className="form-label">
                            Site or Department making the request <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            value={formData.department}
                            onChange={(e) =>
                                handleInputChange("department", e.target.value)
                            }
                            className={`form-input ${errors.department ? "error" : ""}`}
                            placeholder="Enter site or department"
                        />
                        {errors.department && (
                            <p className="error-message">{errors.department}</p>
                        )}
                    </div>

                    {/* Principal */}
                    <div className="form-group">
                        <label className="form-label">
                            Director, Principal, or Designee
                            <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            value={formData.principal}
                            onChange={(e) =>
                                handleInputChange("principal", e.target.value)
                            }
                            className={`form-input ${errors.principal ? "error" : ""}`}
                            placeholder="Enter name"
                        />
                        {errors.principal && (
                            <p className="error-message">{errors.principal}</p>
                        )}
                    </div>

                    {/* Principal Email */}
                    <div className="form-group">
                        <label className="form-label">
                            Email for Director, Principal, or Designee <span className="required">*</span>
                        </label>
                        <input
                            type="email"
                            value={formData.principalEmail}
                            onChange={(e) => handleInputChange("principalEmail", e.target.value)}
                            className={`form-input ${errors.principalEmail ? "error" : ""}`}
                            placeholder="Enter email"
                        />
                        {errors.principalEmail &&
                            <p className="error-message">{errors.principalEmail}</p>
                        }
                    </div>

                    {/* File Upload */}
                    <div className="form-group">
                        {/* File upload box at the bottom with drag and drop */}
                        <div>
                            <Controller
                                name="files"
                                control={control}
                                defaultValue={[]}
                                rules={{
                                    required: "Please upload at least one file",
                                    validate: (value) =>
                                        value.length > 0 || "Please upload at least one file",
                                }}
                                render={({ field }) => (

                                    <div
                                        onDragEnter={(e) => {
                                            handleDrag(e);
                                        }}
                                        onDragOver={(e) => {
                                            handleDrag(e);
                                        }}
                                        onDragLeave={(e) => {
                                            handleDrag(e);
                                        }}
                                        onDrop={(e) => {
                                            setErrors((prev) => ({ ...prev, files: "" }));
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setDragActive(false);
                                            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                                                // const filesArr = Array.from(e.dataTransfer.files).filter(
                                                //   (file) => file.type.startsWith("image/")
                                                // );
                                                setSelectedFiles((prev) => {
                                                    const newFiles = [...prev, ...e.dataTransfer.files];
                                                    field.onChange(newFiles);
                                                    return newFiles;
                                                });
                                            }
                                        }}
                                        style={{
                                            height: 240,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: dragActive ? "2px solid #1976d2" : "2px dashed #ccc",
                                            borderRadius: 8,
                                            padding: 32,
                                            textAlign: "center",
                                            marginTop: 16,
                                            marginBottom: 10,
                                            background: dragActive ? "#e3f2fd" : "#fafbff",
                                            transition: "all 0.2s",
                                            position: "relative",
                                            outline: dragActive ? "2px solid #1976d2" : "none",
                                        }}
                                    >
                                        <input
                                            type="file"
                                            ref={inputRef}
                                            style={{ display: "none" }}
                                            accept=".pdf,.doc,.docx,.txt,.csv,.rtf,.xls,.xlsx,.ppt,.pptx"
                                            multiple
                                            onChange={(e) => {
                                                setErrors((prev) => ({ ...prev, files: "" }));
                                                if (e.target.files && e.target.files.length > 0) {
                                                    const filesArr = Array.from(e.target.files); // ✅ Always convert FileList -> Array<File>

                                                    setSelectedFiles((prev) => {
                                                        const newFiles = [...prev, ...filesArr]; // ✅ Proper array of File objects
                                                        field.onChange(newFiles);
                                                        return newFiles;
                                                    });

                                                    setValue(""); // clear input value
                                                }
                                            }}
                                        />

                                        <div
                                            style={{
                                                color: "#6F8DFF",
                                                fontWeight: 600,
                                                fontSize: 22,
                                                marginBottom: 16,
                                            }}
                                        >
                                            Browse or Drag and Drop{" "}
                                            <span
                                                style={{
                                                    color: "#6c889c",
                                                    fontWeight: 400,
                                                    fontSize: 18,
                                                    marginLeft: 12,
                                                }}
                                            ><br />
                                                (PDF, DOC, DOCX, TXT, CSV, RTF, XLS, XLSX, PPT, PPTX)
                                            </span>
                                        </div>
                                        <SubmitButton
                                            btnText="Browse Files"
                                            buttonType="button"
                                            handleSubmit={handleBrowseClick}
                                        />
                                    </div>
                                )}
                            />
                            {errors.files && (
                                <div className="error-message">
                                    {errors.files}
                                </div>
                            )}
                        </div>

                        {/* Table for selected images */}
                        {selectedFiles.length > 0 && (
                            <div
                                style={{
                                    marginTop: 4,
                                    marginBottom: 14,
                                    borderRadius: 14,
                                    overflow: "hidden",
                                    boxShadow: "0 2px 12px #e0e7ef",
                                    background: "#f8fafc",
                                    border: "1.5px solid #e0e7ef",
                                }}
                            >
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "separate",
                                        borderSpacing: 0,
                                        background: "#f8fafc",
                                        fontSize: 15,
                                        color: "#6c889c",
                                    }}
                                >
                                    <thead>
                                        <tr style={{ background: "#f4f7fb" }}>
                                            <th
                                                style={{
                                                    padding: "16px 10px",
                                                    fontWeight: 700,
                                                    textAlign: "left",
                                                    color: "#6c889c",
                                                    borderBottom: "1.5px solid #e0e7ef",
                                                }}
                                            >
                                                #
                                            </th>
                                            <th
                                                style={{
                                                    padding: "16px 8px",
                                                    fontWeight: 700,
                                                    textAlign: "left",
                                                    color: "#6c889c",
                                                    borderBottom: "1.5px solid #e0e7ef",
                                                    borderLeft: "1.5px solid #e0e7ef",
                                                }}
                                            >
                                                File
                                            </th>

                                            <th
                                                style={{
                                                    padding: "16px 8px",
                                                    fontWeight: 700,
                                                    textAlign: "left",
                                                    color: "#6c889c",
                                                    borderBottom: "1.5px solid #e0e7ef",
                                                }}
                                            >
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedFiles.map((file, idx) => (
                                            <tr
                                                key={idx}
                                                style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}
                                            >
                                                <td
                                                    style={{
                                                        padding: "14px 8px",
                                                        textAlign: "center",
                                                        borderBottom: "1px solid #e0e7ef",
                                                        borderRight: "1.5px solid #e0e7ef",
                                                    }}
                                                >
                                                    {idx + 1}
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "14px 8px",
                                                        borderBottom: "1px solid #e0e7ef",
                                                        borderRight: "1.5px solid #e0e7ef",
                                                    }}
                                                >
                                                    {file.name}
                                                </td>

                                                <td
                                                    style={{
                                                        padding: "14px 8px",
                                                        textAlign: "center",
                                                        borderBottom: "1px solid #e0e7ef",
                                                    }}
                                                >
                                                    <span
                                                        onClick={() => handleRemoveFile(idx)}
                                                        style={{
                                                            color: "#d32f2f",
                                                            cursor: "pointer",
                                                            fontWeight: 600,
                                                            textDecoration: "underline",
                                                            padding: "8px 10px",
                                                            borderRadius: 6,
                                                            transition: "background 0.15s",
                                                            userSelect: "none",
                                                            display: "inline-block",
                                                        }}
                                                        onMouseOver={(e) =>
                                                            (e.currentTarget.style.background = "#ffeaea")
                                                        }
                                                        onMouseOut={(e) =>
                                                            (e.currentTarget.style.background = "transparent")
                                                        }
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <Trash2Icon size={18} />
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* Submit */}
                    <div className="form-group" style={{ textAlign: "center" }}>
                        <button onClick={onSubmit} type="button" className="nav-button success">
                            Submit Request
                            <CheckCircle size={20} style={{ marginLeft: "0.5rem" }} />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div className="copy_right" style={{ textAlign: 'center', margin: '2rem', fontSize: '15px', lineHeight: '1.5' }}>
            <p>Copyright 2025 <a href="https://algovisolutions.com/">Algovi Services LLC.</a> All rights reserved</p>
        </div>
        {loading && (
            <div className="loader_wrapper">
                <img src="/images/form_loader.svg" alt="" />
            </div>
        )}
        {/* Same CSS as before */}
        <style jsx>{`
        .app-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(#6f8dff, #57ccf3);
          padding: 1rem;
          flex-direction: column;
        }
        .step-description {
          color: #000000ff;
          line-height: 1.4;
          text-align: start;
        }
        .form-group {
          margin-bottom: 1.5rem;
        }
        .step-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 0.8rem;
          line-height: 1.3;
          text-align: start;
        }
        .step-header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .header {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 10px;
        }
          .input-image{
            padding: 0;
            border: none;
          }
          .input-image .form-input{
          border: 1px solid #d1d5db;
        }
        .logo_wrapper {
          margin-bottom: 7px;
        }
        .logo_wrapper img {
          height: 80px;
        }
        .main-title {
          font-size: 2.4rem;
          font-weight: bold;
          color: #fff;
          margin-bottom: 2rem;
          text-align: center;
        }
        .form-container {
          max-width: 48rem;
          margin: 0 auto;
        }
        .form-card {
          background: white;
          border-radius: 0.5rem;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          padding: 2rem;
          min-width: 660px;
        }
        .form-label {
          display: block;
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          margin-bottom: 0.5rem;
          line-height: 1.5;
        }
        .form-input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem;
          font-size: 1rem;
          transition: all 0.2s ease;
          box-sizing: border-box;
        }
        select.form-input {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 0.75rem center;
          background-size: 1.8rem;
        }
          .loader_wrapper{
            height: 100vh;
            width: 100vw;
            background-color: #ffffffb2;
            position: fixed;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            }
            .loader_wrapper img{
                height: 70px;
                animation: loader .8s infinite linear;
        }
        @keyframes loader{
            from{
                transform: rotate(0deg);
            }
            to{
                transform: rotate(360deg);
            }
        }
        .form-input:focus {
          outline: none;
          border-color: transparent;
          box-shadow: 0 0 0 2px #6f8dff;
        }
        .form-input.error {
          border-color: #ef4444;
        }
        .nav-button.success:hover {
          background: #059669;
        }
           .nav-button {
          display: flex;
          align-items: center;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-weight: 500;
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 1rem;
        }
           .nav-button.success {
          background-color: #059669;
          color: white;
        }
          .form-select{
                padding-right: 40px !important;
          }
                .required {
          color: #ef4444;
        }
          
        @media (max-width: 850px) {
  .form-card {
    min-width: 100%;
  }
  .main-title {
    font-size: 2.3rem;
  }
  .logo_wrapper img {
    height: 75px;
  }
  .logo_wrapper {
    margin-bottom: 0px;
  }
}

@media (max-width: 650px) {
  .main-title {
    font-size: 1.8rem;
  }
  .step-title {
    font-size: 1.6rem;
  }
  select.form-input {
    background-size: 1.5rem !important;
  }
}

@media (max-width: 470px) {
  .form-card {
    padding: 1.2rem;
  }
      .step-description{
    font-size: 15px; 
}
  .logo_wrapper img {
    height: 65px;
  }
  .main-title {
    font-size: 1.8rem;
    margin-bottom: 1.9rem;
  }
  .step-title {
    font-size: 1.4rem;
  }
  .form-input {
    font-size: 0.95rem;
  }
    .nav-button {
    font-size: 0.9rem;
    padding: 0.65rem 1.1rem;
  }
}



      `}</style>
    </div >
);
};

export default TranslationRequestForm;
